let quiller;
let messageEditor;
let addedMessageListenerAlready;
let pn = window.location.pathname;

let leaveMessageModal;

let dataUse;
let messageAction = 'Contact';
let toLabel;
let suportEmail;

function leaveMessage(toSupport) {
	console.log('Leave Message');

	if (!document.getElementById('subjectInput').value.length) {
		document.getElementById('subjectInput').classList.add('invalid');
		return;
	}

	let subject = DOMPurify.sanitize(document.getElementById('subjectInput').value);
	let message = quiller ? DOMPurify.sanitize(quiller.root.innerHTML) : '';
	if (!message) {
		console.warn('Message editor not initialized, sending empty message');
	}
	message = message.replace(/<p>|<br>/g, '');
	message = message.replace(/<\/p>/g, '<br>');
	let sending = true;

	leaveMessageModal.innerHTML = `
		<div class="loader loader--style6 center-align p-2" title="5">
			${loader}
			<p class="mt-4">Hold tight, we're sending your message.</p>
		</div>
	`;

	// Send emails
	let confirmationMessage = `Your message was sent to ${toLabel}`;
	let leaveMessageUrl = 'https://api.nthround.io/portal/auth/send-email';

	axios
		.post(
			leaveMessageUrl,
			JSON.stringify({
				userid: authedUser,
				client: client,
				cookie: cookie,
				sender_name: userData.user_name,
				recipient: toSupport ? suportEmail : clientData.contact_email,
				subject: subject + ' (via ' + client + '.nthround.io)',
				message: message,
			})
		)
		.then((response) => {
			console.log(response);
			// TODO: Add file URL to ClientConfiguration
			// document.getElementById('sendMessage').innerHTML = `
			// 	<div class="py-20 bg-grey-lightest border-blue-dotted rounded center-align">
			// 		<i class="medium material-icons text-primary">access_time</i>
			// 		<h5 class="text-xl font-bold mb-2 mt-1">Your import is in progress</h5>
			// 	<p class="mt-0 max-w-sm mx-auto">We’re working on getting your cap table imported so you can manage your stock book and issue new equity quickly and easily. We’ll notify you when the import is complete.</p>
			// 	</div>
			// `
			leaveMessageModal.innerHTML = `
			<div class="p-2 center-align">
				<div class="mb-4"><img src="./../../resources/assets/celebrate-v4.svg" alt="Musicians celebrating" class="responsive-img px-12"/></div>
				<h3 class="text-lg mb-4 mt-4 font-bold">${confirmationMessage}</h3>
			</div>
		`;
			// TODO: Reset the UI to show in progress import
			console.log('Your message has been sent', response);
		})
		.catch(function (error) {
			console.error(error);
		});
}

async function initModal() {
	leaveMessageModal = document.getElementById('leaveMessageModal');
	if (!leaveMessageModal) return;
	if (!clientData) return;
	if (!clientData.company_name) clientData.company_name = 'the Company';
	if (!userData) userData = {};
	if (!userData.user_name) userData.user_name = 'an investor';

	leaveMessageModal.innerHTML = `
		<div class="modal-content">
			<div class="mt-4 row mb-0">
				<div class="col s12">
					<h3 class="text-xl font-bold mb-0">${messageAction} ${toLabel}</h3>
				</div>
			</div>
			<div class="row mb-0">
				<div class="input-field col s12 mb-0">
					<input id="subjectInput" class="validate subject-input" type="text" name="subject" required placeholder="Enter your email subject" />
					<span class="helper-text" data-error="Please enter a subject for your email."></span>
				</div>
				<div class="col s12">
					<div id="messageEditor" style="background: #fff;">
						<p>Hi, <br><br><br></p>
					</div>
				</div>
				<button id="leaveMessageTrigger" class="btn bg-grey-darker right mt-6 mr-4">Send Request</button>
				<!--<div class="col s12 flex justify-between items-center mt-4">
					<p class="text-sm"><a id="sendTestMessageTrigger" href="#">Send test email</a></p>
					<button id="leaveMessageTrigger" class="btn bg-grey-darker">Send Message</button>
				</div>-->
			</div>
		</div>
	`;

	let senderName = userData.user_name;
	if (userData.userid != authedUser) senderName = authedUser + ' on behalf of ' + userData.user_name;
	document.getElementById('subjectInput').value = (dataUse == 'support' ? 'Support Request from ' : 'New Request from ') + senderName;

	let toolbarOptions = [
		['bold', 'italic', 'underline'], // toggled buttons
		['blockquote', 'link'],
		[{ header: 1 }, { header: 2 }], // custom button values
		[{ list: 'ordered' }, { list: 'bullet' }],
	];

	if (!pn.includes('/admin') && !pn.includes('/calendar')) {
		// Lazy load Quill for message editor
		const Quill = await window.loadQuill();

		// The modal (and #messageEditor within it) can have been torn down/re-rendered
		// while the above await was in flight — re-check before handing Quill a selector.
		if (!document.getElementById('messageEditor')) return;

		quiller = new Quill('#messageEditor', {
			theme: 'snow',
			placeholder: 'Compose your message...',
			modules: {
				toolbar: toolbarOptions,
			},
		});

		document.getElementById('leaveMessageTrigger').addEventListener('click', function (e) {
			e.preventDefault();
			if (window.analytics)
				window.analytics.track('Contact Nth Support Message Sent', {
					userEmail: authedUser,
					workspace: client,
				});
			leaveMessage(dataUse == 'support');
		});
	}
}

function formatImg(img, transformation) {
	if (img == undefined || img.length < 49) return '';
	let transform = transformation;
	let start = img.slice(0, 49);
	let end = img.slice(49);
	img = (start + transform + end).replace(/\/\//g, '/').replace(/:\//g, '://');
	return img;
}

function setHeader(company_name, user, contact_email, plan, use_real_estate_language, use_fund_language, language) {
	//console.log("NAV: " + company_name, user, plan + ", use_real_estate_language = " + use_real_estate_language);
	// Dynamically set the page title

	let labelShareholders = use_fund_language ? 'Investors' : 'Shareholders';
	let labelUpdatesTab = (language ? language.label_updates_tab : null) || 'Updates';
	let labelPortfolioTab = 'Portfolio';
	let labelTeamTab = 'Team';
	let labelReportsTab = FUNDING ? 'Financials' : 'Reports';
	let labelDataRoomTab = 'Data Room';
	if (language) {
		if (language.label_shareholders) labelShareholders = language.label_shareholders;
		if (language.label_portfolio_tab) labelPortfolioTab = language.label_portfolio_tab;
		if (language.label_team_tab) labelTeamTab = language.label_team_tab;
		if (language.label_reports_tab) labelReportsTab = language.label_reports_tab;
		if (language.label_data_room_tab) labelDataRoomTab = language.label_data_room_tab;
	}

	let leaveMessageLink = document.getElementById('leaveMessageLink');
	let leaveMessageMenu = document.getElementById('leaveMessageMenu');
	let contactSupport = document.getElementById('contactSupport');
	if (!addedMessageListenerAlready) {
		addedMessageListenerAlready = true;
		if (leaveMessageLink) {
			leaveMessageLink.addEventListener('click', function (e) {
				e.preventDefault();
				if (window.analytics) {
					window.analytics.track('Leave Message Dashboard Button Clicked', {
						userEmail: authedUser,
						workspace: client,
					});
				}
				setLeaveMessage(true);
			});
		}
	}
	if (leaveMessageMenu) {
		leaveMessageMenu.addEventListener('click', function (e) {
			e.preventDefault();
			if (window.analytics) {
				window.analytics.track('Request Information Menu Button Clicked', {
					userEmail: authedUser,
					workspace: client,
				});
			}
			setLeaveMessage(true);
		});
	}
	if (contactSupport) {
		contactSupport.addEventListener('click', function (e) {
			e.preventDefault();
			setLeaveMessage(false);
		});
	}
	function setLeaveMessage(itsMsg) {
		messageAction = itsMsg ? 'Request Information from' : 'Contact';
		dataUse = itsMsg ? 'message' : 'support';
		if (itsMsg) {
			toLabel = language?.label_send_message ? language.label_send_message : clientData.company_name;
		} else {
			suportEmail = clientData.support_email || clientData.contact_email;
			toLabel = clientData.company_name + ' Support';
		}
		if (!suportEmail) {
			suportEmail = 'support@nthround.com';
			toLabel = 'Nth Round Support';
		}
		initModal();
	}

	document.title = `${company_name} | ${clientData.invite_words ? clientData.invite_words : use_fund_language ? 'Investor' : 'Shareholder'} Dashboard`;

	switch (pn) {
		default:
			document.title = `${company_name} | ${clientData.invite_words ? clientData.invite_words : use_fund_language ? 'Investor' : 'Shareholder'} Portal`;
			break;
		case '/team/':
			document.title = `${labelTeamTab} | ${company_name}`;
			break;
		case '/portfolio/':
			document.title = `${labelPortfolioTab} | ${company_name}`;
			break;
		case '/faq/':
			document.title = `Q & A | ${company_name}`;
			break;
		case '/updates/':
			document.title = `${labelUpdatesTab} | ${company_name}`;
			break;
		case '/documents/':
			document.title = `Your Documents | ${company_name}`;
			break;
		case '/profile/':
			document.title = `Your Profile | ${company_name}`;
			break;
		case '/campaign/':
			document.title = `${campaignName || 'Campaign'} | ${company_name}`;
			break;
		case '/figures/':
			document.title = `Equity Structure | ${company_name}`;
			break;
		case '/reports/':
			document.title = `${labelReportsTab} | ${company_name}`;
			break;
		case '/data-room/':
			document.title = `${labelDataRoomTab} | ${company_name}`;
			break;
		case '/trade/':
			document.title = `Liquidity | ${company_name}`;
			break;
		case '/calendar/':
			document.title = `Company Calendar`;
			break;
		case '/admin/calendar/':
			document.title = `Company Calendar Admin`;
			break;
		case '/admin/profile/':
			document.title = `Company Profile | ${company_name}`;
			break;
		case '/admin/users/':
			document.title = `Manage ${labelShareholders} | ${company_name}`;
			break;
		case '/admin/allocator/':
			document.title = `Income allocator | ${company_name}`;
			break;
		case '/admin/tax-forms/':
			document.title = `Tax Forms | ${company_name}`;
			break;
		case '/admin/signatures/':
			document.title = `Signatures Admin | ${company_name}`;
			break;
		case '/admin/surveying/':
			document.title = `Surveying Admin | ${company_name}`;
			break;
		case '/admin/voting/':
			document.title = `Voting Admin | ${company_name}`;
			break;
		case '/admin/enrollment/':
			document.title = `Enrollment Admin | ${company_name}`;
			break;
		case '/admin/buy-sell/':
			document.title = `Buy Sell Admin | ${company_name}`;
			break;
		case '/admin/payments/':
			document.title = `Payments Admin | ${company_name}`;
			break;
		case '/admin/requests/':
			document.title = `Requests Admin | ${company_name}`;
			break;
		case '/admin/fundraising/':
			document.title = `Fundraising Admin | ${company_name}`;
			break;
		// case "/admin/updates/":
		// 	document.title = `${labelUpdatesTab} Admin | ${company_name}`;
		// 	break;
		// case "/admin/reports/":
		// 	document.title = `${labelReportsTab} Admin | ${company_name}`;
		// 	break;
		case '/admin/ledgers/':
			document.title = `Ledgers Admin | ${company_name}`;
			break;
		case '/admin/rooms/':
			document.title = `Rooms Admin | ${company_name}`;
			break;
		case '/admin/content-mgr/':
			document.title = `Content Manager | ${company_name}`;
			break;
		case '/admin/custom-reports/':
			document.title = `Custom Reports | ${company_name}`;
			break;
	}

	// Dynamically set the favicon
	let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
	link.type = 'image/x-icon';
	link.rel = 'shortcut icon';
	link.href = 'https://www.nthround.io/shared_assets/s3_assets/favicon.ico';
	document.getElementsByTagName('head')[0].appendChild(link);

	// Set custom favicon
	// if (favicon) {
	// 		link.href = favicon;
	// 		document.getElementsByTagName('head')[0].appendChild(link);
	// } else {
	// 		link.href = '/resources/assets/favicon.ico';
	// 		document.getElementsByTagName('head')[0].appendChild(link);
	// }
}

function renderNav(company_name, company_logo, currently_raising, trading_platform, onboarding_guide, use_real_estate_language, client, user, username, flags) {
	let currentUser = authedUser;
	let emailAddr = authedUser;

	function userAvatar() {
		let initials;
		if (userData.friendly_name) initials = getInitials(userData.friendly_name);
		else if (userData.user_name) initials = getInitials(userData.user_name);
		return initials;
	}

	if (!userData) userData = JSON.parse(sessionStorage.getItem('user.Data'));
	let userImg = userData.user_img;
	let blurNames = sessionStorage.getItem('blurnames');
	if (!userImg || userImg.includes('retro')) {
		currentUser = `<div class="flex items-center"><div class="initials">${userAvatar()}</div><i class="material-icons right hide-on-med-and-down">arrow_drop_down</i><div class="hide-on-large-only text-secondary text-sm ml-1">${blurNames ? userData.user_name.replace(/\s/g, '.').toLowerCase() + '@gmail.com' : emailAddr}</div></div>`;
	} else {
		currentUser = `<div class="flex items-center"><img class="navImg" src="${userImg}"></img><i class="material-icons right hide-on-med-and-down">arrow_drop_down</i><div class="hide-on-large-only text-secondary text-sm ml-1">${blurNames ? userData.user_name.replace(/\s/g, '.').toLowerCase() + '@gmail.com' : emailAddr}</div></div>`;
	}

	language = clientData.language;
	itsaFund = clientData.use_fund_language || clientData.use_real_estate_language;
	let labelShareholders = itsaFund ? 'Investors' : 'Shareholders';
	let labelUpdatesTab = (language ? language.label_updates_tab : null) || 'Updates';
	let labelPortfolioTab = 'Portfolio';
	let labelTeamTab = 'Team';
	let labelReportsTab = FUNDING ? 'Financials' : 'Reports';
	let labelDataRoomTab = 'Data Room';
	let labelEquityType = 'Shares';
	if (language) {
		if (language.label_shareholders) labelShareholders = language.label_shareholders;
		if (language.label_portfolio_tab) labelPortfolioTab = language.label_portfolio_tab;
		if (language.label_team_tab) labelTeamTab = language.label_team_tab;
		if (language.label_reports_tab) labelReportsTab = language.label_reports_tab;
		if (language.label_data_room_tab) labelDataRoomTab = language.label_data_room_tab;
		if (language.label_equitytype) labelEquityType = language.label_equitytype;
	}

	let tabs = clientData.tabs || {};
	let hideUpdates = tabs.hide_updates;
	let hideReports = tabs.hide_reports;
	let hideYourDocs = tabs.hide_your_docs;
	let hideLedgers = tabs.hide_ledgers;
	let hideCustomReports = tabs.hide_custom_reports;

	// These may have leagacy values outside tabs node
	let showTeam = tabs.show_team || clientData.team_page;
	let showPortfolio = tabs.show_portfolio || clientData.portfolio_page;

	let showFAQ = tabs.show_faq_tab;
	let showCalendar = tabs.show_company_calendar;
	let showSHCalendar = tabs.show_users_calendar;
	let hideMessage = flags && flags.hide_leave_message;
	let showCampaign = SHOW_INVEST && tabs.show_campaign; // SHOW_INVEST is user-by-user

	let showDataRoom = false;
	const requiredTags = clientData.data_room_tags;
	const userTags = userData.clients[client].tags || [];
	if (tabs.show_data_room) {
		// Admin bypasses tag checks, but not the tab switch
		if (isAdmin) showDataRoom = true;
		else if (!Array.isArray(requiredTags) || requiredTags.length === 0) showDataRoom = true;
		else if (requiredTags.some((tag) => userTags.includes(tag))) showDataRoom = true;
	}

	const tROOMS = !VOA && tabs.show_rooms_admin;
	const tVOTING = !VOA && tabs.show_voting_admin;
	const tENROLL = !VOA && tabs.show_enroll_admin;
	const tBUYSELL = !VOA && tabs.show_buysell_admin;
	const tPAYMENTS = !VOA && tabs.show_payments_admin;
	const tREQUESTS = !VOA && tabs.show_requests_admin;
	const tFORM1099 = !VOA && tabs.show_form_1099_admin;
	const tALLOCATOR = !VOA && tabs.show_allocator_admin;
	const tCONTENT_MGR = !VOA && tabs.show_content_admin;
	const tSURVEYING = !VOA && tabs.show_surveying_admin;
	const tSIGNATURES = !VOA && tabs.show_signatures_admin;
	const tFUNDRAISING = !VOA && tabs.show_fundraising_admin;
	const tCUSTOM_REPORTS = !VOA && tabs.show_custom_reports_admin;

	let taxOnly;
	let canTrade;
	let viewLink;
	let adminLink;
	let navButton;
	let hasAliases;
	let canPreviewYourProfile;
	let href = window.location.href;

	if (userData?.clients?.[client]) {
		let userClientData = userData.clients[client];
		let userClientShares = userClientData.shares;
		let userShareKeys = userClientShares ? Object.keys(userClientShares) : [];

		isAdmin = userData.carlist?.includes('^' + client);
		isCont = userClientData.tags?.includes('CONTRIBUTOR') || false;
		isSupv = userClientData.tags?.includes('SUPERVISOR') || false;
		isExec = userClientData.tags?.includes('EXECUTIVE') || false;

		canPreviewYourProfile = (getAuthType().includes('admin') && !VOA) || userData.userid == authedUser;
		const aliasData = JSON.parse(sessionStorage.getItem('alias.Data') || '[]');
		// Defensive check: already filtering nulls, add optional chaining in map for extra safety
		const aliasIds = aliasData.filter((entry) => entry?.userid).map((entry) => entry?.userid);
		if (aliasIds.includes(userData.userid)) canPreviewYourProfile = true;

		if (isAdmin) {
			adminLink = `<li><a id="goToAdmin" href="${pn.includes('admin') ? '/' : '/admin/users/'}">${pn.includes('admin') ? 'View ' + (clientData.invite_words ? clientData.invite_words : itsaFund ? 'Investor Portal' : 'Shareholder Portal') : 'Go to Admin'}</a></li>`;
		} else if ((isSupv || isExec) && pn != '/supervisor/') {
			adminLink = `<li><a id="goToSupv" href="/supervisor/">${isExec ? 'Executive' : 'Supervisor'} View</a></li>`;
		} else {
			adminLink = '';
		}

		if (!(isAdmin || isCont)) {
			viewLink = `<li><a id="contactSupport" href="#leaveMessageModal" class="modal-trigger">Contact Support</a></li>`;
		}

		if (currentUser)
			navButton = `<a id="userDropdownTrigger" class="dropdown-trigger text-secondary border-l-1" href="#!" data-target="userDropdown">${currentUser}</a>`;
		else navButton = `<a class="waves-effect waves-light bg-grey-darker btn modal-trigger" href="#requestAccessModal">Request Access</a>`;

		if (userClientShares)
			userShareKeys.forEach((k) => {
				if (Number(userClientShares[k].approved) > 0 || userClientShares[k].permitPurchase) {
					canTrade = true;
					return;
				}
			});

		const USE_ACH = isAlera || isStaging || isONW || ['onwardfe'].includes(client);
		if (USE_ACH) {
			let shDocs = userClientData.documents;
			let abbrev = client == 'aleragroup' ? ' AMP' : ' OMP'; // can't use isAlera
			let alreadyAgreed = shDocs ? shDocs.find((d) => d.name && d.name.includes(new Date().getFullYear() + abbrev + ' Participation Agreement')) : null;
			let alreadySigned = shDocs ? shDocs.find((d) => d.name && d.name.includes(new Date().getFullYear() + ' Accredited Investor Questionnaire')) : null;
			if (userClientData.investor && userClientData.investor.signed && userClientData.investor.election == 'Sell')
				alreadySigned = userClientData.investor.signed;
			let bankConnected = userData.ach_record?.bank_name;
			let alreadyEnrolled = alreadyAgreed && alreadySigned && bankConnected;
			canTrade = alreadyEnrolled && userData.ach_record.acct_id && userClientData.investor.investorId;
			if (BUYERS_ONLY && userClientData.investor && userClientData.investor.election == 'Sell') canTrade = false;
		}

		// simpler and more relaible
		hasAliases = sessionStorage.getItem('hasAliases');
		// hasAliases = document.getElementById('workSpaceModalTrigger');
		// hasAliases = pn == '/' && !!(userClientData.alias?.length || sessionStorage.getItem('alias.Data'));

		let userTags = userData.clients[client].tags;
		if (userTags && userTags.includes('TAX ONLY')) {
			hideUpdates = true;
			hideReports = true;
			showTeam = false;
			showPortfolio = false;
			canTrade = false;
			currently_raising = false;
			taxOnly = true;
		}
	}

	let nav = document.getElementById('nav');
	if (!nav) return;

	nav.innerHTML = `
		<nav>
			<!-- Dropdown Structure -->
			<ul id='userDropdown' class='dropdown-content'>
				<li><div class="dropSummary">${blurNames ? userData.user_name.replace(/\s/g, '.').toLowerCase() + '@gmail.com' : stripSubAddress(userData.userid)}</div></li>
				${adminLink ? `<li class="divider" tabindex="-1"></li>` : ``}
				${!taxOnly && canPreviewYourProfile ? `<li><a href="/profile/">Your Profile</a></li>` : ``}
				${hasAliases ? `<li class="workspaceModalMenu"><a href="#" onclick="switchAccount()" >Switch Account</a></li>` : ``}
				${pn == '/admin/profile/' ? `<li><a href="/admin/users/">Go to Admin</a></li>` : pn.includes('/admin') && !VOA ? `<li><a href="/admin/profile/">Company Profile</a></li>` : ``}
				${canTrade && !pn.includes('/admin') && clientData.trading_platform ? `<li><a href="/trade/">Buy/Sell Platform</a></li>` : ``}
				<!--${trading_platform && onboarding_guide && currentUser ? `<li><a class="text-secondary" href="/trade/#settings">Start Guide</a></li>` : ``}-->
				<li class="divider" tabindex="-1"></li>
				${adminLink}
				${viewLink || ''}
				<li class="divider" tabindex="-1"></li>
				<!--${!pn.includes('/admin') && !hideMessage ? `<li><a id="leaveMessageMenu" href="#leaveMessageModal" class="modal-trigger">Leave a Message</a></li>` : ``}-->
				<li><a id="logoutButton" class="log-out" href="#">Sign Out</a></li>
			</ul>
			<div class="nav-wrapper white">
				<a href="/" class="brand-logo valign-wrapper" style="margin-left: 15px; max-height: 60px;">
					<img id="brandLogo" class="responsive-img" src="${company_logo ? formatImg(company_logo, '/h_48/') : ''}">
				</a>
				<a href="#" data-target="mobile-demo" class="sidenav-trigger right"><i class="material-icons grey-text text-darken-4">menu</i></a>
				<ul id="nav-mobile" class="right hide-on-med-and-down">
					${
						!href.includes('admin')
							? `
						${!taxOnly ? `<li><a class="text-secondary${pn === '/' ? ' active-link' : ''}" href="/">Overview</a></li>` : ``}
						${showFAQ ? `<li><a class="text-secondary${pn === '/faq/' ? ' active-link' : ''}" href="/faq">Q & A</a></li>` : ``}
						${showPortfolio ? `<li><a class="text-secondary${pn === '/portfolio/' ? ' active-link' : ''}" href="/portfolio/">${labelPortfolioTab}</a></li>` : ``}
						${showTeam ? `<li><a class="text-secondary${pn === '/team/' ? ' active-link' : ''}" href="/team/">${labelTeamTab}</a></li>` : ``}
						${!hideUpdates ? `<li><a class="text-secondary${pn === '/updates/' ? ' active-link' : ''}" href="/updates/">${labelUpdatesTab}</a></li>` : ``}
						${!hideReports && currentUser ? `<li><a class="text-secondary${pn === '/reports/' ? ' active-link' : ''}" href="/reports/">${labelReportsTab}</a></li>` : ``}
						${showDataRoom ? `<li><a class="text-secondary" href="/data-room/">${labelDataRoomTab}</a></li>` : ``}

						${currently_raising && activeCampaign && showCampaign ? `<li><a class="text-secondary${pn === '/campaign/' ? ' active-link' : ''}" href="/campaign/">${activeCampaign?.name || 'Active Campaign'}</a></li>` : ``}

						${!hideYourDocs && currentUser ? `<li><a class="text-secondary${pn === '/documents/' ? ' active-link' : ''}" href="/documents/">Your Documents</a></li>` : ``}

						${showSHCalendar && showCalendar ? `<li><a class="text-secondary${pn === '/calendar/' ? ' active-link' : ''}" href="/calendar/">Calendar</a></li>` : ``}
						<!--${!pn.includes('/admin') && !hideMessage ? `<li><a href="#leaveMessageModal" class="modal-trigger">Leave a Message</a></li>` : ``}-->
						<li>${navButton}</li>
						${currentUser ? '' : `<li><a class="text-secondary" href="/signin/">Sign In</a></li>`}
						<!--${trading_platform && onboarding_guide && currentUser ? `<li><a class="text-secondary" href="/trade/#settings"><i class="material-icons">import_contacts</i></a></li>` : ``}-->
					`
							: `
						<!--<li><a class="text-secondary${pn === '/admin/dashboard/' ? ' active-link' : ''}" href="/admin/dashboard/">Dashboard</a></li>-->
						<li><a class="text-secondary${pn === '/admin/users/' ? ' active-link' : ''}" href="/admin/users/">${labelShareholders}</a></li>

						${tFORM1099 ? `<li><a class="text-secondary${pn === '/admin/tax-forms/' ? ' active-link' : ''}" href="/admin/tax-forms/">Tax Forms</a></li>` : ``}
						${tALLOCATOR ? `<li><a class="text-secondary${pn === '/admin/allocator/' ? ' active-link' : ''}" href="/admin/allocator/">Income Allocator</a></li>` : ``}
						${tSIGNATURES ? `<li><a class="text-secondary${pn === '/admin/signatures/' ? ' active-link' : ''}" href="/admin/signatures/">Signatures</a></li>` : ``}
						${tSURVEYING ? `<li><a class="text-secondary${pn === '/admin/surveying/' ? ' active-link' : ''}" href="/admin/surveying/">Surveying</a></li>` : ``}
						${tVOTING ? `<li><a class="text-secondary${pn === '/admin/voting/' ? ' active-link' : ''}" href="/admin/voting/">Voting</a></li>` : ``}
						${tENROLL ? `<li><a class="text-secondary${pn === '/admin/enrollment/' ? ' active-link' : ''}" href="/admin/enrollment/">Enrollment</a></li>` : ``}
						${tBUYSELL ? `<li><a class="text-secondary${pn === '/admin/buy-sell/' ? ' active-link' : ''}" href="/admin/buy-sell/">Buy Sell</a></li>` : ``}
						${tPAYMENTS ? `<li><a class="text-secondary${pn === '/admin/payments/' ? ' active-link' : ''}" href="/admin/payments/">Payments</a></li>` : ``}
						${tREQUESTS ? `<li><a class="text-secondary${pn === '/admin/requests/' ? ' active-link' : ''}" href="/admin/requests/">Requests</a></li>` : ``}
						${tFUNDRAISING ? `<li><a class="text-secondary${pn === '/admin/fundraising/' ? ' active-link' : ''}" href="/admin/fundraising/">Fundraising</a></li>` : ``}

						${!hideLedgers ? `<li><a class="text-secondary${pn === '/admin/ledgers/' ? ' active-link' : ''}" href="/admin/ledgers/">Ledgers</a></li>` : ``}
						${tROOMS ? `<li><a class="text-secondary${pn === '/admin/rooms/' ? ' active-link' : ''}" href="/admin/rooms/">Rooms</a></li>` : ``}
						${tCUSTOM_REPORTS ? `<li><a class="text-secondary${pn === '/admin/custom-reports/' ? ' active-link' : ''}" href="/admin/custom-reports/">Custom Reports</a></li>` : ``}
						${tCONTENT_MGR ? `<li><a class="text-secondary${pn === '/admin/content-mgr/' ? ' active-link' : ''}" href="/admin/content-mgr/">Content Manager</a></li>` : ``}
						${showCalendar ? `<li><a class="text-secondary${pn === '/admin/calendar/' ? ' active-link' : ''}" href="/admin/calendar/">Calendar</a></li>` : ``}
						<li>${navButton}</li>
					`
					}
					<li></li>
					
				</ul>
			</div>
		</nav>

		<ul class="sidenav right" id="mobile-demo">
			${
				!href.includes('admin')
					? `
				<li><a href="/" class="font-bold">${blurNames ? userData.user_name.replace(/\s/g, '.').toLowerCase() + '@gmail.com' : stripSubAddress(userData.userid)}</a></li>
				<li>${adminLink}</li>
				${viewLink ? `<li>${viewLink}</li>` : ''}
				<li class="divider" tabindex="-1"></li>
				${!taxOnly ? `<li><a class="text-secondary" href="/">Overview</a></li>` : ``}
				${showFAQ ? `<li><a class="text-secondary" href="/faq/">Q & A</a></li>` : ``}
				${showPortfolio ? `<li><a class="text-secondary" href="/portfolio/">${labelPortfolioTab}</a></li>` : ``}
				${showTeam ? `<li><a class="text-secondary" href="/team/">${labelTeamTab}</a></li>` : ``}
				${!hideUpdates ? `<li><a class="text-secondary" href="/updates/">${labelUpdatesTab}</a></li>` : ``}
				${!hideReports && currentUser ? `<li><a class="text-secondary" href="/reports/">${labelReportsTab}</a></li>` : ``}
				${showDataRoom ? `<li><a class="text-secondary" href="/data-room/">${labelDataRoomTab}</a></li>` : ``}
				${showSHCalendar && showCalendar ? `<li><a class="text-secondary${pn === '/calendar/' ? ' active-link' : ''}" href="/calendar/">Calendar</a></li>` : ``}

				${currently_raising && activeCampaign && showCampaign ? `<li><a class="text-secondary${pn === '/campaign/' ? ' active-link' : ''}" href="/campaign/">${activeCampaign?.name || 'Active Campaign'}</a></li>` : ``}

				${!hideYourDocs && currentUser ? `<li><a class="text-secondary" href="/documents/">Your Documents</a></li>` : ''}
				${currentUser ? `<li class="divider" tabindex="-1"></li>` : ''}
				${!taxOnly && canPreviewYourProfile ? `<li><a href="/profile/" class="text-secondary">Your Profile</a></li>` : ``}
				${hasAliases ? `<li class="workspaceModalMenu"><a href="#" onclick="switchAccount()" class="text-secondary">Switch Account</a></li>` : ``}
				${canTrade && currentUser && clientData.trading_platform ? `<li><a class="text-secondary" href="/trade/">Buy/Sell Platform</a></li>` : ``}

				<!--${trading_platform && onboarding_guide && currentUser ? `<li><a class="text-secondary" href="/trade/#settings">Start Guide</a></li>` : ``}-->
				${currentUser ? `<li class="divider mt-0" tabindex="-1"></li>` : ''}
				${
					currentUser
						? `
					<!--${!pn.includes('/admin') && !hideMessage ? `<li><a id="leaveMessageMenu" href="#leaveMessageModal" class="modal-trigger text-secondary">Leave a Message</a></li>` : ``}-->
					<li><a class="text-secondary log-out" href="#">Sign Out</a></li>
					`
						: ''
				}
				${!currentUser ? '<li>' + navButton + '</li>' : ''}
				${!currentUser ? `<li><a class="text-secondary modal-trigger" href="/signin/">Sign In</li>` : ``}
			`
					: `
				<li><a href="/" class="font-bold">${currentUser}</a></li>
				<li>${adminLink}</li>
				${adminLink.length ? `<li class="divider" tabindex="-1"></li>` : ``}
				<li><a class="text-secondary" href="/admin/users/">${labelShareholders}</a></li>

				${tFORM1099 ? `<li><a class="text-secondary${pn === '/admin/tax-forms/' ? ' active-link' : ''}" href="/admin/tax-forms/">Tax Forms</a></li>` : ``}
				${tALLOCATOR ? `<li><a class="text-secondary${pn === '/admin/allocator/' ? ' active-link' : ''}" href="/admin/allocator/">Income Allocator</a></li>` : ``}
				${tSIGNATURES ? `<li><a class="text-secondary${pn === '/admin/signatures/' ? ' active-link' : ''}" href="/admin/signatures/">Signatures</a></li>` : ``}
				${tSURVEYING ? `<li><a class="text-secondary${pn === '/admin/surveying/' ? ' active-link' : ''}" href="/admin/surveying/">Surveying</a></li>` : ``}
				${tVOTING ? `<li><a class="text-secondary${pn === '/admin/voting/' ? ' active-link' : ''}" href="/admin/voting/">Voting</a></li>` : ``}
				${tENROLL ? `<li><a class="text-secondary${pn === '/admin/enrollment/' ? ' active-link' : ''}" href="/admin/enrollment/">Enrollment</a></li>` : ``}
				${tBUYSELL ? `<li><a class="text-secondary${pn === '/admin/buy-sell/' ? ' active-link' : ''}" href="/admin/buy-sell/">Buy Sell</a></li>` : ``}
				${tPAYMENTS ? `<li><a class="text-secondary${pn === '/admin/payments/' ? ' active-link' : ''}" href="/admin/payments/">Payments</a></li>` : ``}
				${tREQUESTS ? `<li><a class="text-secondary${pn === '/admin/requests/' ? ' active-link' : ''}" href="/admin/requests/">Requests</a></li>` : ``}
				${tFUNDRAISING ? `<li><a class="text-secondary${pn === '/admin/fundraising/' ? ' active-link' : ''}" href="/admin/fundraising/">Fundraising</a></li>` : ``}

				${!hideLedgers ? `<li><a class="text-secondary" href="/admin/ledgers/">Ledgers</a></li>` : ``}
				${tROOMS ? `<li><a class="text-secondary" href="/admin/rooms/">Rooms</a></li>` : ``}
				${tCUSTOM_REPORTS ? `<li><a class="text-secondary${pn === '/admin/custom-reports/' ? ' active-link' : ''}" href="/admin/custom-reports/">Custom Reports</a></li>` : ``}

				${tCONTENT_MGR ? `<li><a class="text-secondary" href="/admin/content-mgr/">Content Manager</a></li>` : ``}
				${showCalendar ? `<li><a class="text-secondary${pn === '/admin/calendar/' ? ' active-link' : ''}" href="/admin/calendar/">Calendar</a></li>` : ``}

				<!--<li><a class="text-secondary" href="/admin/guide/">Quick Start Guide</a></li>-->

				<li class="divider" tabindex="-1"></li>
				${pn === '/admin/profile/' ? `<li><a href="/admin/users/">Go to Admin</a></li>` : pn.includes('/admin') && !VOA ? `<li><a href="/admin/profile/">Company Profile</a></li>` : ``}
				<li><a href="mailto:support@nthround.com" class="text-secondary">Contact Support</a></li>

				<!--${trading_platform && onboarding_guide && currentUser ? `<li><a class="text-secondary" href="/trade/#settings">Start Guide</a></li>` : ``}-->

				<li class="divider mt-0" tabindex="-1"></li>
				${hasAliases ? `<li class="workspaceModalMenu"><a href="#" onclick="switchAccount()">Switch Account</a></li>` : ``}
				<li><a class="text-secondary log-out" href="#">Sign Out</a></li>
			`
			}
			<!--<li>${navButton}</li>-->
		</ul>
		<div id="leaveMessageModal" class="modal modal-sm"></div>
	`;

	window.switchAccount = function () {
		if (window.location.pathname !== '/') window.location.href = `/?openModal=workspaceModal`;
		else {
			M.Modal.getInstance(document.getElementById('workspaceModal')).open();
			history.replaceState(null, '', '/');
		}
	};

	let userDropdown = document.getElementById('userDropdown');
	nav.addEventListener('click', function (e) {
		this.dispatchEvent(new Event('touchcancel'));
	});
	userDropdown.addEventListener('click', function (e) {
		this.dispatchEvent(new Event('touchcancel'));
	});

	// for iOS13 disable touchend events (https://github.com/Dogfalo/materialize/issues/6514)
	nav.addEventListener('touchend', function (e) {
		if (e.isTrusted) e.stopPropagation();
	});
	userDropdown.addEventListener('touchend', function (e) {
		if (e.isTrusted) e.stopPropagation();
	});

	let quiller;
	let sidenavOptions = {};
	let dropdownOptions = {
		coverTrigger: false,
		constrainWidth: false,
	};
	let modalOptions = {
		onOpenStart: initModal,
	};

	let sideNavElems = document.querySelectorAll('.sidenav');
	let modalElems = document.querySelectorAll('.modal');
	let dropdownElems = document.getElementById('userDropdownTrigger');
	if (typeof M !== 'undefined' && M != null) {
		M.Sidenav.init(sideNavElems, sidenavOptions);
		M.Dropdown.init(dropdownElems, dropdownOptions);
		M.Modal.init(modalElems, modalOptions);
	}

	if (taxOnly && !pn.includes('/documents')) window.location.replace('/documents/');
}

function getNavData(client) {
	// On admin pages, re-read from sessionStorage to revert from Observer/Preview mode
	if (pn.includes('/admin/')) {
		userData = JSON.parse(sessionStorage.getItem('user.Data'));
		clientData = JSON.parse(sessionStorage.getItem(client + '.Data'));
	}
	if (pn.includes('/admin/') && (!clientData || !userData || userData.userid != authedUser)) {
		axios
			.get(clientURL, {
				params: {
					client: client,
					userid: authedUser,
					cookie: cookie,
					host: window.location.host,
				},
			})
			.then(function (response) {
				userData = response.data[0]['user'];
				sessionStorage.setItem('user.Data', JSON.stringify(userData));
				goAheadWithNav();
				clientData = response.data[1]['client'];
				sessionStorage.setItem(client + '.Data', JSON.stringify(clientData));
				sessionStorage.removeItem('alias.Data');
			});
	} else {
		goAheadWithNav();
	}

	function goAheadWithNav() {
		const blurLogo = 'https://res.cloudinary.com/nthround/image/upload/v1572380359/ttvhqbxnsnpcsds6wk79.png';
		if (clientData) {
			LIVE_TRADING = clientData.trading_platform;
		}
		if (clientData && userData) {
			const client_logo = blurNames ? blurLogo : clientData.company_logo;
			const currently_raising = clientData.currently_raising;
			const trading_platform = clientData.trading_platform;
			const onboarding_guide = clientData.onboarding_guide;
			const use_real_estate_language = clientData.use_real_estate_language;
			const use_fund_language = clientData.use_fund_language;
			const company_name = clientData.company_name;
			const user = userData.userid;
			const username = userData.user_name;
			const contact_email = userData.userid;
			const plan = clientData.plan;
			const language = clientData.language;
			const flags = clientData.flags;

			if (clientData.language?.label_send_message) {
				toLabel = clientData.language?.label_send_message;
			} else if (clientData.company_name) {
				toLabel = clientData.company_name;
			} else {
				toLabel = 'Nth Round Support';
			}

			suportEmail = clientData.support_email || clientData.contact_email || 'support@nthround.com';

			renderNav(
				company_name,
				client_logo,
				currently_raising,
				trading_platform,
				onboarding_guide,
				use_real_estate_language,
				client,
				user,
				username,
				flags
			);
			setHeader(company_name, userData, contact_email, plan, use_real_estate_language, use_fund_language, language);
		}
	}
}

document.addEventListener('ReadyToRender', function () {
	getNavData(client);
	initModal();

	// Deep link from an approval-gate-v1 email (gate.py) — opens the approval as an
	// overlay on top of whatever page it lands on, instead of navigating to the
	// standalone /actions/action/ page. Registered here (not per-page) so it works
	// wherever the admin landing page happens to be. Skipped on /actions/action/
	// itself, which already renders wf_exec_id inline (see action.js's own
	// ReadyToRender listener) — opening the modal there too would double it up.
	// Also skipped on /admin/requests/, which opens the same wf_exec_id into its own
	// bespoke TransferRequestReviewContent overlay instead (see requests.js) — this
	// generic modal would otherwise open alongside it.
	const approvalParams = new URLSearchParams(location.search);

	// Deep link to the workflow config overlay, e.g. from an internal admin
	// link: ?wf_config_modal=true&wf_definition_id=<client>::<workflow_type>::<workflow_name>
	// opens a single record's editor; ?wf_config_modal=true&wf_client=<client>
	// (no wf_definition_id) opens the list of every definition for that client.
	// Registered here (not per-page) for the same reason as the wf_exec_id
	// block below -- it needs to work regardless of which page the admin lands
	// on. nth-admin only: this is an internal config tool, not user-facing.
	const wfConfigModalFlag = approvalParams.get('wf_config_modal');
	const wfDefinitionId = approvalParams.get('wf_definition_id');
	const wfClient = approvalParams.get('wf_client');
	if (wfConfigModalFlag === 'true' && window.AppState?.nthAdmin) {
		if (wfDefinitionId) {
			import(/* webpackChunkName: "vue-wf-config-modal" */ './helpers/wf-config-modal-bootstrap.js').then(({ openWfConfigModal }) =>
				openWfConfigModal(wfDefinitionId)
			);
		} else if (wfClient) {
			import(/* webpackChunkName: "vue-wf-config-modal" */ './helpers/wf-config-modal-bootstrap.js').then(({ openWfConfigModalList }) =>
				openWfConfigModalList(wfClient)
			);
		}
	}

	const approvalExecId = approvalParams.get('wf_exec_id');
	if (approvalExecId && !window.location.pathname.startsWith('/actions') && !window.location.pathname.startsWith('/admin/requests')) {
		import(/* webpackChunkName: "actions-action" */ '../actions/action.js').then(async ({ openApprovalModal, fetchApprovalPreview }) => {
			// Equity-award approval links open the award's own review (helpers/wf/equity-award.js).
			if (await handleEquityAwardLink(approvalExecId)) return;
			const taskToken = approvalParams.get('task_token') || null;
			const approvalId = approvalParams.get('approval_id') || null;
			// view_type=modal|fullscreen; anything else (including absent) defaults to modal.
			const viewType = approvalParams.get('view_type') || null;

			// Resolved up front (rather than only in the await-approvals-v1 branch below) so
			// notice-generation-v1 can be identified even when the link carries a task_token --
			// e.g. its own approval-gate-v1 email link. `execData === undefined` means the
			// lookup itself failed (network/auth error) — fall through to the normal modal so
			// the admin sees an error instead of nothing.
			const { execData, decision } = await fetchApprovalPreview(approvalExecId, taskToken, approvalId).catch(() => ({
				execData: undefined,
				decision: null,
			}));

			// #6318: payments.js opens ach-payer-onboarding links into its own approval overlay or wizard;
			// ACH distribution approval links on the same page still use the modal below.
			if (window.location.pathname.startsWith('/admin/payments') && execData?.workflow_type?.startsWith('ach-payer-onboarding')) return;

			// notice-generation-v1's progress should show as the live status tracker rather
			// than the generic modal's static outcome screen once a decision has been made --
			// a bare ?wf_exec_id= resume/reload link (this page's own, pushed once a send
			// starts) always lands here, and so does its formal approval-gate-v1 email link
			// once current_step has moved past awaiting_approval. But while that email link's
			// approval is still pending, fall through to the same openApprovalModal flow every
			// other approval-gate-v1 workflow uses below -- it carries the real task_token/
			// approval_id and full context details needed to actually decide it, which this
			// status tracker doesn't have. Checked via workflow_type (stable) rather than
			// workflow_name, which gets clobbered to the WfDefinition's friendly_name once
			// merged with a still-pending WorkflowApprovalRequests record (see
			// wf-load-config.py's substitution and fetchExecutionForApproval's Object.assign
			// merge).
			if (execData?.workflow_type === 'notice-generation-v1') {
				const stillAwaitingApproval = (taskToken || approvalId) && execData.current_step === 'awaiting_approval';
				if (!stillAwaitingApproval) {
					document.dispatchEvent(new CustomEvent('wf:resume-notice-generation', { detail: { executionId: approvalExecId, execData } }));
					return;
				}
			}

			// Formal approval-gate-v1 links (gate.py) always carry task_token/approval_id --
			// e.g. wiring-details-import, and notice-generation-v1 while still pending (see
			// above). These should feel instant, so open the modal right away. Unlike the
			// await-approvals-v1 case below, a reload of one of these after it's been decided
			// should still show the outcome (its own tracking display doesn't surface
			// approve/reject the way the ACH campaign page does) -- so no dismissIfDecided
			// here; let it render the normal completion panel. (notice-generation-v1 never
			// reaches this branch once decided -- it's caught by the tracker redirect above.)
			if (taskToken || approvalId) {
				openApprovalModal(approvalExecId, {
					taskToken,
					approvalId,
					viewType,
					prefetched: execData !== undefined ? { execData, decision } : null,
				});
				return;
			}

			// await-approvals-v1 links (e.g. ACH distribution campaigns) carry neither --
			// this is the flow whose "already decided" detection needed fixing, and where
			// popping the modal open only to close it again a moment later was visibly janky
			// (see plan notes). Check the outcome BEFORE opening anything.
			if (execData !== undefined && decision && (decision.autoApproved || decision.timedOut || decision.alreadyDecided)) {
				return;
			}

			openApprovalModal(approvalExecId, {
				taskToken,
				approvalId,
				viewType,
				dismissIfDecided: true,
				// Already fetched above — skip loadActionData's own re-fetch so the modal
				// renders with content immediately instead of flashing "Loading…" first.
				prefetched: execData !== undefined ? { execData, decision } : null,
			});
		});
	}
});

// Only the award's admin page (its approval email's portal_path) carries equity-award runs, so other pages'
// links skip the extra lookup.
function handleEquityAwardLink(executionId) {
	if (!window.location.pathname.startsWith('/admin/ledgers')) return Promise.resolve(false);
	return import(/* webpackChunkName: "wf-equity-award" */ './helpers/wf/equity-award.js')
		.then(({ handleEquityAwardDeepLink }) => handleEquityAwardDeepLink(executionId))
		.catch(() => false);
}

document.addEventListener('FinallyLoaded', function () {
	initModal();
});
